import useSWR, { SWRResponse } from "swr";
import { ISavingProposalResponse } from "../../../types/robot/ISavingProposalResponse";
import { IUseSavingProposal } from "./types";
import commonSwrConfig from "@portal/hooks/commonSwrConfig";
import useCenterId from "@portal/hooks/useCenterId";
import { useSession } from "@portal/auth/client/SessionProvider";
import { ISavingProposalRequest } from "@portal/types/robot/ISavingProposalRequest";

const useSavingProposal: IUseSavingProposal = (request: ISavingProposalRequest) => {
  const centerId = useCenterId();
  const { update } = useSession();

  const path = `/api/robot/SavingProposal?centerId=${centerId}`;

  const fetcher = (url: URL) =>
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...request, firstName: "", lastName: "" }),
    }).then(res => res.json());

  const { data, error }: SWRResponse<ISavingProposalResponse, unknown> = useSWR(path, fetcher, commonSwrConfig(update));
  const response = { data, error, isLoading: !data && !error };

  return response;
};

export default useSavingProposal;
